import { render, staticRenderFns } from "./YuleZiyuanFenxi.vue?vue&type=template&id=3983eda9&scoped=true&"
import script from "./YuleZiyuanFenxi.vue?vue&type=script&lang=js&"
export * from "./YuleZiyuanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983eda9",
  null
  
)

export default component.exports